import { ReactComponent as SvgBusd } from './BUSD.svg.es.js';
import { ReactComponent as SvgDai } from './DAI.svg.es.js';
import { ReactComponent as SvgEurc } from './EURC.svg.es.js';
import { ReactComponent as SvgFrax } from './FRAX.svg.es.js';
import { ReactComponent as SvgTusd } from './TUSD.svg.es.js';
import { ReactComponent as SvgUsdc } from './USDC.svg.es.js';
import { ReactComponent as SvgUsdt } from './USDT.svg.es.js';
import { ReactComponent as SvgUst } from './UST.svg.es.js';

const SvgStablecoinIcons = {
    BUSD: SvgBusd,
    DAI: SvgDai,
    EURC: SvgEurc,
    FRAX: SvgFrax,
    TUSD: SvgTusd,
    USDC: SvgUsdc,
    USDT: SvgUsdt,
    UST: SvgUst
};

export { SvgStablecoinIcons };
//# sourceMappingURL=index.es.js.map
